import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { notification } from 'antd';
import AutoCompleteInput from './AutoCompleteInput';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import { filterRow } from '../utils/ktcUtils';
import DeleteModal from './DeleteModal';

const DataEntryTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
  setData,
}) => {
  console.log("--- DHAMMAAN PROPS-KA ---");
  console.log("Data:", data);
  console.log("Link Object:", link);
  console.log("Token:", token);
  console.log("Report Footer:", reportFooter);

  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [processedRows, setProcessedRows] = useState([]);
  // ✅ Default: xog ku qoran rows kaliya check - empty rows ma checked
  const [selectedRows, setSelectedRows] = useState(() => {
    const filledIndexes = data
      .map((row, i) => ({ row, i }))
      .filter(({ row }) =>
        Object.entries(row).some(([key, val]) => {
          const type = key.split('~')[2];
          if (type === 'hide') return false;
          return val !== null && val !== undefined && val !== '' && val !== 0 && val !== '0';
        })
      )
      .map(({ i }) => i);
    return new Set(filledIndexes);
  });
  const [showApiUpdateButton, setShowApiUpdateButton] = useState(false);
  const [originalData, setOriginalData] = useState(data);
  const [filteredData, setFilteredData] = useState(data);
  const [failedData, setFailedData] = useState([]);

  const inputRef = useRef(null);

  // ✅ DELETE LOGIC - DTTable ka copy
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [updateTable, setUpdateTable] = useState(link?.table_name);

  const handleDelete = (id, table = '') => {
    setDeleteId(id);
    if (table !== '') setUpdateTable(table);
    setDeleteModalVisible(true);
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setDeleteId(null);
  };

  const handleDeleteSuccess = (deletedId) => {
    // Row-ka filtered ka saar marka delete guuleysto
    setFilteredData((prev) => prev.filter((row) => {
      const idKey = Object.keys(row).find(k => k === 'ID' || k.split('~')[1] === 'id');
      return String(row[idKey]) !== String(deletedId);
    }));
    setOriginalData((prev) => prev.filter((row) => {
      const idKey = Object.keys(row).find(k => k === 'ID' || k.split('~')[1] === 'id');
      return String(row[idKey]) !== String(deletedId);
    }));
    setDeleteModalVisible(false);
    setDeleteId(null);
    notification.success({ message: 'Record deleted successfully' });
  };

  // ✅ ISBEDDELKA 1: paid, discount, bankId - default 0, data ka soo buuxiya useEffect
  const [discount, setDiscount] = useState(0);
  const [bankId, setBankId] = useState(0);
  const [bankOptions, setBankOptions] = useState();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  console.log('selectedRows:', selectedRows);
  // ✅ DEBUG: Row keys-ka muuji si aan ID-ga u ogaanno
  if (filteredData.length > 0) {
    console.log('🔑 Row keys:', Object.keys(filteredData[0]));
    console.log('🔑 Row values:', filteredData[0]);
  }

  const totalKey = columns?.find((col) => col.key === 'total')?.key || 'total';

  // subTotal - checked rows kaliya xisaabi
  const selectedRowIndexes = Array.from(selectedRows);
  const selectedRowsArray = Array.from(selectedRowIndexes)
    .map((rowIndex) => filteredData[rowIndex])
    .filter((row) => row !== undefined);

  const subTotal = selectedRowsArray.reduce((sum, row) => {
    const rowTotal = Number(row[totalKey]) || 0;
    return sum + rowTotal;
  }, 0);

  const vatCommission = 0;

  // ✅ ISBEDDELKA 3: paid - default 0, data ka soo buuxiya
  const [paid, setPaid] = useState(0);
  const vat = (subTotal - discount) * vatCommission;
  const balance = subTotal - Number(discount) + vat - Number(paid);

  useEffect(() => {
    const columnKeys = Object.keys(data[0]);

    const cols = columnKeys.map((col) => {
      const parts = col.split('~');
      const columnName = col;
      const header = parts[0];
      const key = parts[1] || parts[0];
      const type = parts[2];
      const inputId = parts[3];
      const colIndex = parts[4];

      const isDropdown = type?.includes('dropdown');
      const isCheckbox = type?.includes('checkbox');
      const isEditable = type === 'editable' || type === 'api_url';
       const autoHideKeys = ['paid', 'discount', 'bank'];
  const isHidden = type === 'hide' || 
    (parts.length === 1 && autoHideKeys.includes(parts[0].toLowerCase()));


      return {
        columnName,
        header,
        key,
        type,
        inputId,
        colIndex,
        isDropdown,
        isCheckbox,
        editable: isEditable,
        visible: !isHidden,
        dropdownOptions: isDropdown ? [] : null,
      };
    });

    setColumns(cols);

    if (data?.length > 0) {
      const firstRow = data[0];
 // ✅ Helper: find key by alias (parts[1]) OR name (parts[0]) if no alias
  const findKey = (alias) =>
    Object.keys(firstRow).find((k) => {
      const parts = k.split('~');
      return parts[1] === alias || (parts.length === 1 && parts[0] === alias);
    });

  // paid
  const paidKey = findKey('paid');
  if (paidKey) {
    const paidValue = parseFloat(firstRow[paidKey]) || 0;
    setPaid(paidValue);
  }

  // discount
  const discountKey = findKey('discount');
  if (discountKey) {
    const discountValue = parseFloat(firstRow[discountKey]) || 0;
    setDiscount(discountValue);
  }

  // bank
  const bankKey = findKey('bank');
  if (bankKey) {
    const bankValue = firstRow[bankKey] || 0;
    setBankId(bankValue);
  }

      // api_url button
      const hasApiUrlColumn = Object.keys(firstRow).some(
        (key) => key.split('~')[2] === 'api_url'
      );
      setShowApiUpdateButton(hasApiUrlColumn);
    }

    const fetchAllDropdowns = async (cols) => {
      for (const col of cols) {
        if ((col.isDropdown || col.isCheckbox) && col.inputId) {
          const url = `${API_URL}/${ENDPOINTS.SYS}/get-dropdown/${col.inputId}`;
          try {
            const response = await axios.get(url, {
              headers: { Authorization: token ? `Bearer ${token}` : '' },
            });
            const options = response.data;
            setColumns((prevColumns) =>
              prevColumns.map((c) =>
                c.key === col.key ? { ...c, dropdownOptions: options } : c
              )
            );
          } catch (err) {
            console.error(`Dropdown fetch failed for ${col.inputId}`, err);
          }
        }
      }
    };

    const fetchBankDropdowns = async () => {
      const url = `${API_URL}/${ENDPOINTS.SYS}/get-dropdown/${link.update_link_id}`;
      try {
        const response = await axios.get(url, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        setBankOptions(response.data);
      } catch (err) {
        console.error(`Dropdown fetch failed for bank input id: ${link.update_link_id}`, err);
      }
    };

    if (cols.length) fetchAllDropdowns(cols);
    fetchBankDropdowns();
  }, []);

  // ✅ ISBEDDELKA 5: samacompany - paid ha iskeed u cusboonaanin
  useEffect(() => {
    const isSamaCompany = API_URL.includes('samacompany');
    if (isSamaCompany) {
      // paid waxay u taagan tahay hore la bixiyay - ha taaban
      return;
    } else {
      setPaid(subTotal - discount + vat);
    }
  }, [subTotal, discount, vat]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    const filtered = originalData.filter((row) =>
      Object.values(row).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const updateApiValues = async () => {
    setLoading(true);
    const successfulRows = [];
    const failedRows = [];

    try {
      for (let i = 0; i < filteredData.length; i++) {
        const row = filteredData[i];
        const updatedRow = { ...row };
        const fetchPromises = [];

        for (const columnKey in row) {
          const parts = columnKey.split('~');
          if (parts[2] === 'api_url' && parts.length >= 3) {
            const targetKey = parts[3];
            const originalUrl = row[columnKey];

            fetchPromises.push(
              axios
                .get(`${API_URL}/${ENDPOINTS.SYS}/proxy`, {
                  params: { url: originalUrl },
                  timeout: 5000,
                  headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                  const newValue = response.data?.[targetKey];
                  if (newValue !== undefined) {
                    const targetColumn = Object.keys(row).find(
                      (k) => k.split('~')[3] === targetKey
                    );
                    if (targetColumn) updatedRow[targetColumn] = newValue;
                  } else {
                    updatedRow[`error_${targetKey}`] = true;
                  }
                })
                .catch((err) => {
                  console.log(`Failed to fetch ${originalUrl}`, err.message);
                  updatedRow[`error_${targetKey}`] = true;
                })
            );
          }
        }

        await Promise.allSettled(fetchPromises);

        const hasError = Object.keys(updatedRow).some((key) =>
          key.startsWith('error_')
        );

        if (hasError) failedRows.push(updatedRow);
        else successfulRows.push(updatedRow);
      }

      setFilteredData(successfulRows);
      setOriginalData(successfulRows);
      setFailedData(failedRows);
    } catch (error) {
      console.error('Unexpected error:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateRowFromString = (rowIndex, str) => {
    setFilteredData((currentFiltered) => {
      const updatedFiltered = [...currentFiltered];
      const targetRow = { ...updatedFiltered[rowIndex] };

      const updates = Object.fromEntries(
        str.split(',').map((pair) => {
          const [k, v] = pair.split(':');
          return [k.trim(), v.trim()];
        })
      );

      Object.keys(targetRow).forEach((key) => {
        const secondPart = key.split('~')[1];
        if (updates.hasOwnProperty(secondPart)) {
          targetRow[key] = updates[secondPart];
        }
      });

      updatedFiltered[rowIndex] = targetRow;
      return updatedFiltered;
    });
  };

  const handleEdit = async (e, rowIndex2, colData, row, colIndex) => {
    try {
      const columnName = colData.columnName;
      const updatedData = [...data];
      const updatedFiltered = [...filteredData];

      let text = e.target.textContent;
      let str = '';

      if (
        colData.type.includes('dropdown') ||
        colData.type === 'autocomplete' ||
        colData.type === 'input'
      ) {
        text = e.target.value;
        str = e.target.info;
      }

      const findMatchingRowIndex = (filteredRow, originalData) => {
        return originalData.findIndex((origRow) => {
          const keysToCompare = Object.keys(filteredRow).filter(
            (k) => !k.includes('~options')
          );
          return keysToCompare.every((key) => filteredRow[key] === origRow[key]);
        });
      };

      const rowIndex = findMatchingRowIndex(row, updatedData);
      if (rowIndex === -1) return;
      if (updatedData[rowIndex][columnName] === text) return;

      if (colData.type === 'load-dropdown') {
        try {
          setLoading(true);
          const url = `${API_URL}/${ENDPOINTS.SYS}/load-dropdown/${colData.inputId}/${text}`;
          const response = await axios.get(url, {
            headers: { Authorization: token ? `Bearer ${token}` : '' },
          });
          const newOptions = response.data.results;
          const targetColIndex = parseInt(colData.colIndex, 10);
          const optionsKey = `${columns[targetColIndex].columnName}~options`;
          updatedData[rowIndex][optionsKey] = newOptions;
          updatedFiltered[rowIndex2][optionsKey] = newOptions;
        } catch (error) {
          console.error('Error fetching dropdown:', error);
        } finally {
          setLoading(false);
        }
      }

      if (e.target.info) {
        const updates = Object.fromEntries(
          str.split(',').map((pair) => {
            const [k, v] = pair.split(':');
            return [k.trim(), v.trim()];
          })
        );
        Object.keys(updatedData[rowIndex]).forEach((key) => {
          const secondPart = key.split('~')[1];
          if (updates.hasOwnProperty(secondPart)) {
            updatedData[rowIndex][key] = updates[secondPart];
          }
        });
      }

      updatedData[rowIndex][columnName] = text;
      updatedFiltered[rowIndex2][columnName] = text;

      setData(updatedData);
      setFilteredData(updatedFiltered);

      const expression = columnName?.split('~')[3]?.split(',');
      const isSupportNegative = columnName?.split('~')[4] ?? '1';

      if (expression) {
        const uniqueExpressions = [...new Set(expression)];
        uniqueExpressions.forEach((expr) => {
          if (expr) {
            calculateExpression(expr, rowIndex, updatedData[rowIndex], updatedData, setData, isSupportNegative);
          }
        });
        if (uniqueExpressions[0]?.includes('autotick')) {
          handleSubmit(row, rowIndex);
        }
      }
    } catch (err) {
      alert(err);
      console.error('Edit error:', err);
    }
  };

  function calculateExpression(expression, rowIndex, row, updatedData, setData, isSupportNegative) {
    const parts = expression?.split('=');
    const leftSide = parts[0];
    const rightSide = parts[1];

    const delimiterRegex = /[-+*/]/;
    const match = leftSide.match(delimiterRegex);
    if (!match) return;

    const delimiter = match[0];
    const [col1, col2] = leftSide
      .split(delimiter)
      .map((index) => parseInt(index.trim()));

    const col3 = rightSide;

    // ✅ FIX: keys-ka row-ka asalka ah ka qaad (structure)
    // laakiin values-ka updatedData ka qaad (latest values)
    const keys = Object.keys(row);
    const currentRow = updatedData[rowIndex];

    let value1 = currentRow[keys[col1]];
    let value2 = currentRow[keys[col2]];

    var result = 0;

    if (isNaN(parseFloat(value1))) {
      notification.error({
        message: `${keys[col1].split('~')[0]} Value: '${value1}' at index ${col1} is not a number`,
      });
      return;
    }
    if (isNaN(parseFloat(value2))) {
      notification.error({
        message: `${keys[col2].split('~')[0]} Value: '${value2}' at index ${col2} is not a number`,
      });
      return;
    }

    if (delimiter === '-') {
      result = parseFloat(value1) - parseFloat(value2);
      if (result < 0 && isSupportNegative === '0') {
        notification.error({ message: 'The difference is negative.' });
        return;
      }
    } else if (delimiter === '+') {
      result = parseFloat(value1) + parseFloat(value2);
    } else if (delimiter === '*') {
      result = parseFloat(value1) * parseFloat(value2);
    } else if (delimiter === '/') {
      if (parseFloat(value2) === 0) {
        updatedData[rowIndex][keys[col3]] = '0.00';
        setData([...updatedData]);
        return;
      }
      result = parseFloat(value1) / parseFloat(value2);
    }

    updatedData[rowIndex][keys[col3]] =
      value1 === '' || value2 === '' ? '' : result.toFixed(2);

    setData([...updatedData]);
  }

  const handleSubmit = async (row, rowIndex) => {
    const result = await submitRow(row, rowIndex);

    if (result.success) {
      setProcessedRows((prev) => [...prev, rowIndex]);

      const updatedData = originalData.filter(
        (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(row)
      );
      setOriginalData(updatedData);

      const updatedFilteredData = filteredData.filter(
        (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(row)
      );
      setFilteredData(updatedFilteredData);

      if (inputRef.current) inputRef.current.focus();
      setSearch('');
      notification.success({ message: result.message });
    } else {
      notification.error({ message: result.message });
    }
  };

  const renderCell = ({ col, row, rowIndex, colIndex, handleEdit }) => {
    const value = row[col.columnName] || '';

    if (col.type === 'autocomplete') {
      return (
        <AutoCompleteInput
          col={col}
          value={value}
          rowIndex={rowIndex}
          colIndex={colIndex}
          onChange={(id, name, info = '') => {
            handleEdit(
              { target: { value: id, info: info } },
              rowIndex,
              col,
              row,
              colIndex
            );
          }}
        />
      );
    }

    if (col.isDropdown) {
      const options = row[`${col.columnName}~options`] || col.dropdownOptions || [];
      return (
        <select
          className="form-select form-select-sm"
          value={value}
          onChange={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
        >
          <option value="">-- Select --</option>
          {options.map((opt, i) => (
            <option key={i} value={opt.id}>{opt.name}</option>
          ))}
        </select>
      );
    }

    if (col.isCheckbox && Array.isArray(col.dropdownOptions)) {
      const selectedValues = Array.isArray(row[col.columnName]) ? row[col.columnName] : [];
      return (
        <div className="d-flex flex-row">
          {col.dropdownOptions.map((opt) => (
            <label key={opt.id} className="form-check-label me-3">
              <input
                type="checkbox"
                className="form-check-input me-1"
                value={opt.id}
                checked={selectedValues.map(String).includes(String(opt.id))}
                onChange={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
              />
              {opt.name}
            </label>
          ))}
        </div>
      );
    }

    if (col.type === 'input' && col.inputId) {
      return (
        <input
          type={col.inputId}
          className="form-control form-control-sm"
          value={value}
          onChange={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
        />
      );
    }

    if (col.editable) {
      return (
        <div
          contentEditable
          suppressContentEditableWarning
          onBlur={(e) => handleEdit(e, rowIndex, col, row, colIndex)}
        >
          {value}
        </div>
      );
    }

    return value;
  };

  const exportToExcel = (data, title) => {
    const mappedData = data.map((row) => {
      const newRow = {};
      for (const key in row) {
        const firstPart = key.split('~')[0];
        newRow[firstPart] = row[key];
      }
      return newRow;
    });
    const ws = XLSX.utils.json_to_sheet(mappedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, title + '.xlsx');
  };

  const submitRow = async (row, rowIndex) => {
    let filteredRow = filterRow(row);
    filteredRow = {
      ...filteredRow,
      sub_total: subTotal,
      vat: vat,
      discount: discount,
      paid: paid,
      bank_id: bankId,
    };
    const route = filteredRow.api_route;
    delete filteredRow.api_route;

    const insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;

    try {
      const response = await axios.post(insertUrl, filteredRow, {
        headers: { Authorization: token ? `Bearer ${token}` : '' },
      });
      return {
        success: response.data.success === 1,
        message: response.data.message,
        row: filteredRow,
        rowIndex,
      };
    } catch (error) {
      return {
        success: false,
        message: error.message,
        row,
        rowIndex,
      };
    }
  };
const hasAnyId = filteredData.some((row) =>
  Object.keys(row).some((k) => {
    const parts = k.split('~');
    const keyName = parts[0].toLowerCase();
    const keyAlias = (parts[1] || '').toLowerCase();
    return keyName === 'id' || keyAlias === 'id' || k === 'ID';
  })
);
  const handleSubmitAll = async () => {
    const selectedRowIndexes = Array.from(selectedRows);

    if (selectedRowIndexes.length === 0) {
      notification.warning({ message: 'No rows selected to submit.' });
      return;
    }

    const selectedRowsArrayForSubmit = Array.from(selectedRowIndexes)
      .map((rowIndex) => filteredData[rowIndex])
      .filter((row) => row !== undefined);

    const requests = selectedRowsArrayForSubmit.map(
      (row, i) => submitRow(row, selectedRowIndexes[i])
    );

    const results = await Promise.all(requests);
    let successCount = 0;
    let failedCount = 0;

    results.forEach((result) => {
      if (result.success) {
        successCount++;
        setProcessedRows((prev) => [...prev, result.rowIndex]);

        const updatedData = originalData.filter(
          (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(result.row)
        );
        setOriginalData(updatedData);

        const updatedFilteredData = filteredData.filter(
          (dataRow) => JSON.stringify(dataRow) !== JSON.stringify(result.row)
        );
        setFilteredData(updatedFilteredData);
      } else {
        failedCount++;
      }
    });

    notification.info({
      message: `Submit All Result`,
      description: `Success: ${successCount}, Failed: ${failedCount}`,
    });
    if (failedCount === 0) navigate(-1);
  };

  const isSamaCompany = API_URL.includes('samacompany');

  return (
    <div>
      {/* ✅ DELETE MODAL - DTTable ka copy */}
      {deleteId && (
        <DeleteModal
          token={token}
          table={updateTable}
          id={deleteId}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          onSuccess={() => handleDeleteSuccess(deleteId)}
        />
      )}
      <div className="row">
        <div className="col-9">
          {showApiUpdateButton && (
            <button onClick={updateApiValues} className="btn btn-danger" disabled={loading}>
              {loading ? '⏳ Updating...' : '🔄 Update API Values'}
            </button>
          )}
          <button
            onClick={() => exportToExcel(filteredData, `${link.page_title}`)}
            className="btn btn-primary"
          >
            Export Excel
          </button>
          {failedData && failedData.length > 0 && (
            <button
              onClick={() => exportToExcel(failedData, `${link.page_title}-failed`)}
              className="btn btn-danger"
            >
              Export Errors {failedData?.length}
            </button>
          )}
        </div>
        <div className="col-3">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={handleSearch}
            className="form-control mb-3"
            style={{ maxWidth: '300px' }}
            ref={inputRef}
          />
        </div>
      </div>

      <div className="container-fluid">
        <table className="table table-bordered">
          <thead className={isSamaCompany ? 'sama-navy' : 'table-dark'}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={selectedRows.size === filteredData.length}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedRows(new Set(filteredData.map((_, i) => i)));
                    } else {
                      setSelectedRows(new Set());
                    }
                  }}
                />
              </th>
              {columns
                .filter((col) => col.visible && col.key !== 'color')
                .map((col) => (
                  <th key={col.key} className="text-capitalize">
                    {col.header}
                  </th>
                ))}
              {link.hide_tick === '0' && (
                <th>
                  {selectedRows.size > 0 && (
                    <button className="btn btn-primary mb-2" onClick={handleSubmitAll}>
                      Submit Selected Rows ({selectedRows.size})
                    </button>
                  )}
                </th>
              )}
              {hasAnyId && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {filteredData &&
              filteredData.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={
                    row.color ? `row-color-${row.color.trim().toLowerCase()}` : ''
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.has(rowIndex)}
                      onChange={() => {
                        setSelectedRows((prev) => {
                          const updated = new Set(prev);
                          if (updated.has(rowIndex)) updated.delete(rowIndex);
                          else updated.add(rowIndex);
                          return updated;
                        });
                      }}
                    />
                  </td>
                  {columns
                    .filter((col) => col.visible && col.key !== 'color')
                    .map((col, colIndex) => (
                      <td
                        key={col.key}
                        style={
                          col.editable || col.isDropdown || col.type === 'autocomplete'
                            ? { backgroundColor: '#f9f9f9' }
                            : {}
                        }
                      >
                        {renderCell({ col, row, rowIndex, colIndex, handleEdit })}
                      </td>
                    ))}
                  {link.hide_tick === '0' && (
                    <td>
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleSubmit(row, rowIndex)}
                      >
                        ✅
                      </button>
                    </td>
                  )}
            
                 {/* ✅ DELETE BUTTON - Only show if row has ID */}
{hasAnyId && (
  <td>
    {(() => {
      const idKey = Object.keys(row).find((k) => {
        const parts = k.split('~');
        const keyName = parts[0].toLowerCase();
        const keyAlias = (parts[1] || '').toLowerCase();
        return keyName === 'id' || keyAlias === 'id' || k === 'ID';
      });
      const rowId = idKey ? row[idKey] : null;
      const rowTable = row['update_table'] || link?.table_name;

      if (!rowId) return null;

      return (
        <button
          className="btn btn-sm btn-danger"
          title="Delete"
          onClick={() => handleDelete(rowId, rowTable)}
        >
          🗑️
        </button>
      );
    })()}
  </td>
)}
                </tr>
              ))}
          </tbody>
        </table>

        {/* ✅ ISBEDDELKA 6: Sub Total, Discount, VAT, Paid, Balance, Bank */}
        <div className="d-flex flex-column align-items-end mt-3">
          <div className="mb-1">
            <strong>Sub Total:</strong> {!isSamaCompany && ' $'}
            <input
              type="number"
              value={subTotal.toFixed(2)}
              style={{ width: '300px' }}
              readOnly
            />
          </div>
          <div className="mb-1">
            <strong>Discount:</strong> {!isSamaCompany && ' $'}
            <input
              type="number"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              style={{ width: '300px' }}
            />
          </div>
          <div className="mb-1">
            <strong>VAT:</strong> {!isSamaCompany && ' $'}
            <input
              type="number"
              value={vat.toFixed(2)}
              style={{ width: '300px' }}
              readOnly
            />
          </div>
          <div className="mb-1">
            <strong>Paid:</strong> {!isSamaCompany && ' $'}
            <input
              type="number"
              value={paid}
              onChange={(e) => setPaid(e.target.value)}
              style={{ width: '300px' }}
            />
          </div>
          <div className="mb-1">
            <strong>Balance:</strong> {!isSamaCompany && ' $'}
            <input
              type="number"
              value={balance.toFixed(2)}
              style={{ width: '300px' }}
              readOnly
            />
          </div>
          <div className="mb-1">
            <strong>Bank:</strong>{' '}
            <select
              value={bankId}
              onChange={(e) => setBankId(e.target.value)}
              style={{ width: '300px' }}
            >
              <option value="">Select Account</option>
              {bankOptions &&
                bankOptions.length &&
                bankOptions.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {bank.name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="text-end">
          <button className="btn btn-success" onClick={handleSubmitAll}>
            Save Selected - {selectedRows.size} records
          </button>
        </div>
      </div>

      {executionTime !== null && (
        <p>
          Request executed in: {executionTime.toFixed(2)} sec - Total rows:{' '}
          {filteredData && filteredData.length} rows
        </p>
      )}
    </div>
  );
};

export default DataEntryTable;